import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { GymComponent } from './layouts/gym/gym.component';
import { AboutUsComponent } from './about-us/about-us.component';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { CoursesComponent } from './courses/courses.component';
import { ZoomGalleryComponent } from './shared/components/zoom-gallery/zoom-gallery.component';


export const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  {
    path: 'home',
    component: GymComponent,
    data: {
      title: 'גששות בעקבות הטבע',
      content: 'גששות בעיקבות הטבע | בואו לחקור את הנעשה סביבכם | קורסים וסדנאות'
    }
  },
  {
    path: 'blog',
    loadChildren: () => import('@blog/blog.module')
      .then(m => m.BlogModule),
  },
  {
    path: 'gallery',
    component: ZoomGalleryComponent
  },
  {
    path: 'about-us',
    component: AboutUsComponent
  },
  {
    path: 'contact-us',
    component: ContactUsComponent
  },
  {
    path: 'courses',
    component: CoursesComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    // preloadingStrategy: PreloadAllModules,
    anchorScrolling: 'enabled',
    scrollPositionRestoration: 'enabled'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
